import Users from "./forms/Users";
import TablePage from "./Table";
import Schema from "./Schema";
import BlockSelector from "./erp/BlockSelector";
import FloorSelector from "./erp/FloorSelector";
import AllApartments from "./erp/AllApartments";
import DollarRate from "./erp/DollarRate";
import Dashboard from './erp/Dashboard'
import Orders from './erp/Orders'
import DeleteOrders from './erp/DeleteOrders'
import Signatory from './erp/Signatory'
/// Routes for authorized users
export const mainRoutes = [
  {
    path: "/main/dashboard",
    element: <Dashboard />,
    roles: ["admin", "superadmin", "finance","director"],
  },
  {
    path: "/main/table",
    element: <TablePage />,
    roles: ["admin", "superadmin","director"],
  },
  {
    path: ["/main/user", "/main/user/:id"],
    element: <Users />,
    roles: ["admin", "superadmin"],
  },
  {
    path: "/main/schema",
    element: <Schema />,
    roles: ["admin", "superadmin", "manager","director"],
  },
  {
    path: "/main/block-selector",
    element: <BlockSelector />,
    roles: ["admin", "superadmin", "manager","director"],
  },
  {
    path: "/main/floor-selector",
    element: <FloorSelector />,
    roles: ["admin", "superadmin","manager","director"],
  },
  {
    path: "/main/all-apartments",
    element: <AllApartments />,
    roles: ["admin", "superadmin","manager","finance","director"],
  },
  {
    path: "/main/dollar-rate",
    element: <DollarRate />,
    roles: ["admin", "superadmin", "finance","director"],
  },
  {
    path: "/main/orders",
    element: <Orders />,
    roles: ["admin", "superadmin", "finance", "manager","director"],
  },
  {
    path: "/main/delete-orders",
    element: <DeleteOrders />,
    roles: ["admin", "superadmin", "director"],
  },
  {
    path: "/main/signatory",
    element: <Signatory />,
    roles: ["admin", "superadmin"],
  },
  // {
  //   path: "/main/crm/call-center",
  //   element: <CallCenter />,
  //   roles: ["admin", "superadmin"],
  // },
  // {
  //   path: "/main/crm/desktop",
  //   element: <Desktop />,
  //   roles: ["admin", "superadmin"],
  // },
  // {
  //   path: "/main/crm/lead/detail/:id",
  //   element: <LeadDetail />,
  //   roles: ["admin", "superadmin"],
  // },
];


